<template>
  <div>
    <!--<base-header></base-header>-->
    <div class="container">

      <div class="text-center mt10 mb30">
        <img src="/static/ccall.png" class="logo-ccall" width="200" />
      </div>

      <form @submit.prevent="resetPassword">
        <div class="form-header">{{$t('forgotPassword.header')}}</div>
        <div class="form-group">
          <input type="text" class="form-control text-center" v-model="phone" :placeholder="$t('forgotPassword.phone')" :class="{'form-error': errorMessage['phone']}" />
          <p v-for="msg in errorMessage['phone']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group text-center btn-submit">
          <base-button type="submit" class="btn-block" :disabled="phone.length == 0 || isDisabled">{{$t('forgotPassword.next')}}</base-button>
        </div>
      </form>
      <p class="text-footer">
        {{$t('login.dontHaveAccount')}} <router-link :to="{name: 'RegisterPage'}">{{$t('login.signup')}}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
  import BaseButton from "../components/Button.vue";
  import BaseHeader from "../components/Header.vue";

  export default {
    components: {
      BaseHeader,
      BaseButton,
    },
    name: 'ForgotPasswordPage',
    data() {
      return {
        phone: '',
        errorMessage: [],
        isDisabled: false,
      };
    },
    methods: {
      resetPassword() {
        this.isDisabled = true;
        this.errorMessage = [];
        const formData = new FormData();
        formData.append('phone', this.phone);
        this.axios.post('/resetPassword', formData).then((response) => {
          if ((response.data.status)) {
            this.$router.push({name: 'CreateNewPasswordPage', params: {phone: response.data.data.phone, token: response.data.data.token}})
          } else {
            this.isDisabled = false;
            this.errorMessage = response.data.data;
          }
        })
      }
    },
    mounted() {
      const token = localStorage.getItem('token');
      if (token) {
        this.$router.push({name: 'EditPage'});
      }
    }
  };
</script>
<style scoped="">
  .btn-block {
    width: 80% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ForgotPasswordPage.vue